import React, { useState } from "react";
import moment from "moment";
import {
  Typography,
  Button,
  Divider,
  Box,
  Modal,
  Backdrop,
  Fade,
} from "@material-ui/core";

const TimelinePopUp = ({ event, onClose, handleEnroll }) => {
  const [openModal, setOpenModal] = useState(false);

  const {
    title,
    domain,
    date,
    status,
    recording_link,
    content_link,
    quiz_link,
    session_link,
    enrollmentStatus,
  } = event;

  const handleYesClick = () => {
    handleEnroll(event);
    setOpenModal(true);
  };

  const handleModalClose = () => {
    setOpenModal(false);
    onClose();
  };

  return (
    <>
      <Box p={2} minWidth={200} maxWidth={350}>
        <Typography variant="h4" style={{ fontSize: "14px" }} gutterBottom>
          {domain}
        </Typography>
        <Divider style={{ marginBottom: 8 }} />

        <Typography variant="body2" style={{ fontSize: "14px" }} gutterBottom>
          {title}
        </Typography>

        <Box my={1}>
          <Typography
            style={{ fontSize: "14px" }}
            variant="caption"
            display="block"
          >
            <strong>Date:</strong> {moment(date).format("LL")}
          </Typography>
          <Typography
            style={{ fontSize: "14px" }}
            variant="caption"
            display="block"
          >
            <strong>Status:</strong> {status}
          </Typography>
        </Box>

        {enrollmentStatus === "Enrolled" && (
          <>
            <Typography
              variant="body2"
              style={{ fontSize: "14px" }}
              noWrap={false}
              style={{ marginBottom: 8 }}
            >
              {session_link ? (
                <>
                  Do not forget to join the session on the session link:{" "}
                  <a style={{ color: "#0a34ca" }} href={session_link}>
                    {session_link}
                  </a>
                </>
              ) : (
                <>
                  Session link will be provided to your registered email
                  address. Do not forget to join the session on{" "}
                  {moment(date).format("LL")}.
                </>
              )}
            </Typography>
            <Button
              color="primary"
              fullWidth
              variant="contained"
              onClick={onClose}
              style={{ marginBottom: 8 }}
            >
              OK
            </Button>
          </>
        )}
        {status === "Ongoing" && (
          <Typography
            variant="body2"
            style={{ fontSize: "14px" }}
            noWrap={false}
            style={{ marginBottom: 8 }}
          >
            {session_link && (
              <>
                Do not forget to join the session on the session link:{" "}
                <a style={{ color: "#0a34ca" }} href={session_link}>
                  {session_link}
                </a>
              </>
            )}
          </Typography>
        )}

        {status === "Upcoming" && enrollmentStatus !== "Enrolled" && (
          <>
            <Typography variant="h6" style={{ fontSize: "17px" }} gutterBottom>
              Would you like to join the session?
            </Typography>
            <Button
              color="primary"
              fullWidth
              variant="contained"
              onClick={handleYesClick}
              style={{ marginBottom: 8 }}
            >
              Yes
            </Button>
            <Button
              fullWidth
              variant="outlined"
              color="secondary"
              onClick={onClose}
              style={{ marginBottom: 8 }}
            >
              No
            </Button>
          </>
        )}

        {status === "Completed" && (
          <>
            {recording_link && (
              <Button
                fullWidth
                variant="outlined"
                color="primary"
                href={recording_link}
                style={{ marginBottom: 8, fontSize: "14px" }}
              >
                Watch Session Recording
              </Button>
            )}
            {content_link && (
              <Button
                fullWidth
                variant="outlined"
                color="secondary"
                href={content_link}
                style={{ marginBottom: 8 }}
              >
                View Resources
              </Button>
            )}
            {quiz_link && (
              <Button
                fullWidth
                variant="outlined"
                color="default"
                href={quiz_link}
                style={{ marginBottom: 8 }}
              >
                Take a Quiz
              </Button>
            )}
          </>
        )}

        {status === "Pending" && (
          <Typography
            variant="caption"
            color="textSecondary"
            style={{ fontSize: "14px" }}
          >
            Registration will open soon
          </Typography>
        )}
      </Box>
      <Modal
        open={openModal}
        onClose={handleModalClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 300,
        }}
      >
        <Fade in={openModal}>
          <Box
            bgcolor="background.paper"
            p={3}
            borderRadius={4}
            mx="auto"
            my="20%"
            maxWidth={600}
            boxShadow={24}
            textAlign="center"
          >
            <Typography variant="h5" gutterBottom>
              Email Sent
            </Typography>
            <Typography
              variant="body1"
              style={{ fontSize: "14px" }}
              gutterBottom
            >
              The session link has been sent on your registered email address.
              Do not forget to join the session on {moment(date).format("LL")}.
            </Typography>
            <Button
              variant="contained"
              color="primary"
              onClick={handleModalClose}
              style={{ marginTop: 16 }}
            >
              OK
            </Button>
          </Box>
        </Fade>
      </Modal>
    </>
  );
};

export default TimelinePopUp;
